// In-memory access token (Front-End.md §0: access in memory, refresh in localStorage).
// The token is an opaque ES256 JWT — the FE never verifies it.
let accessToken: string | null = null;
export const getAccessToken = () => accessToken;
export const setAccessToken = (t: string | null) => {
  accessToken = t;
};
